type Config = {
  version: string;
  isLocalhost: boolean;
  byPassSingpassToken: string
  byPassPayment: boolean;
  allowMultipleApplicationDebug: boolean;
  allowPredefinedApplicationCreation: boolean;
  singpassLoginUrl: string;
  myHdbLoginURL: string;
  singpassLogoutUrl: string;
  xApiKey: string;
  stagingPaymentURL: string;
  prodPaymentURL: string;
  showEstimateFees: boolean;
};

let config: Config = {
  version: `${process.env.REACT_APP_RELEASE_VERSION} - 240530.1100`,
  isLocalhost: process.env.REACT_APP_IS_LOCALHOST === "true",
  byPassSingpassToken : `U1BDUFNraXBBdXRoZW50aWNhdGlvbg==`,
  byPassPayment : process.env.REACT_APP_BYPASS_PAYMENT === "true",
  allowMultipleApplicationDebug : process.env.REACT_APP_ALLOW_APPLICATION_DEBUG === "true",
  allowPredefinedApplicationCreation: process.env.REACT_APP_ALLOW_APPLICATION_DEBUG === "true",
  xApiKey : process.env.REACT_APP_POLYMER_X_API_KEY ?? "testing_api_key",
  singpassLoginUrl: `${process.env.REACT_APP_API_DEV_BASE_URL}/oauth2/authorization/hdb-transfer-owner`,
  myHdbLoginURL: "https://services2.hdb.gov.sg/webapp/FI10PPORTAL/FI10PAtAGlance.jsp",
  singpassLogoutUrl: `${process.env.REACT_APP_API_DEV_BASE_URL}/user/logout`,
  stagingPaymentURL: "https://services2u.nicehomes.com.sg/webapp/AC28AWGatewayWeb/AC28QRProcessPayReq.jsp",
  prodPaymentURL: "https://services2.hdb.gov.sg/webapp/AC28AWGatewayWeb/AC28QRProcessPayReq.jsp",
  showEstimateFees: process.env.REACT_APP_SHOW_ESTIMATED_FEES === "true",
};

export default config;
